import React, { useState, useEffect, useRef } from 'react';
import { ProgressBar } from 'primereact/progressbar';
import { DataTable } from 'primereact/datatable';
import classNames from 'classnames';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'; // ← AGREGAR ESTA LÍNEA
import SeleccionDepartamento from '../components/SeleccionDepartamento';
import SeleccionMunicipios from '../components/SeleccionMunicipios';
import SeleccionTipoDocumentoOtros from '../components/SeleccionTipoDocumentoOtros';
import SeleccionProfesion from '../components/SeleccionProfesion';
import SeleccionEstadoTercero from '../components/SeleccionEstadoTercero';
import SeleccionTipoSocio from '../components/SeleccionTipoSocio';
import SeleccionTipoPersona from '../components/SeleccionTipoPersona';
import SeleccionTipoAsociacion from '../components/SeleccionTipoAsociacion';
const Terceros = () => {
    let emptyProduct = {
        TID_TERCERO:'',
        NID_ASOCIACION:'',
        NOMBRE:'',
        DEP_CODIGO:'',
        MUN_CODIGO:'',
        DIRECCION:'',
        TELEFONOS:'',
        CORREO:'',
        URL:'',
        PROFESION:'',
        FECHA_INGRESO:'',
        FECHA_RETIRO:'',
        ESTADO_TERCERO:'',
        TIPO_TERCERO:'',
        TIPO_SOCIO:'',
        NID_TERCERO:'',
    };
    const [products, setProducts] = useState([]);
    const [productDialog, setProductDialog] = useState(false);
    const [product, setProduct] = useState(emptyProduct);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [value1, setValue1] = useState(true)
    const toast = useRef(null);
    const dt = useRef(null);
    const [adicionarRegistro, setAdicionarRegistro] = useState(0)
    const [reloadUsuarios, setReloadUsuarios] = useState(true)
    const [departamento, setDepartamento] = useState(false)
    const [opcion, setOpcion] = useState(false)
    const TERCEROS = 'https://www.ancogenecop.com/APIANCO/controllers/terceros.php?op='
    useEffect(() => {
        if (reloadUsuarios) {
            const recarga = async () => {
                setReloadUsuarios(false)
                await fetch(TERCEROS + 'terceros', {
                    method: 'POST',
                    header: {
                        'Accept': 'application/json',
                        'Content-type': 'application/json'
                    },
                }).then((response) => response.json())
                    .then((response) => {
                        if (response !== []) {
                            setProducts(response)
                        }
                    setValue1(false)
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }
            recarga()
        }
    }, [reloadUsuarios])


    const openNew = () => {
        setProduct(emptyProduct);
        setSubmitted(false);
        setProductDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setProductDialog(false);
    }


    const saveProduct = async() => {
//        setSubmitted(true);
        const nidLimpio = (product.NID_TERCERO || '').replace(/[^0-9]/g, '');
         if(product.TID_TERCERO=='') 
         {
         toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el tipo de identificación del tercero', life: 3000 });
         return;
         }

        if (!nidLimpio) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe digitar el número de identificación del tercero', life: 3000 });
            return;
        } else if(product.NID_TERCERO=='') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe digitar el número de identificación del tercero', life: 3000 });
            return;
        }
   
         if(product.NOMBRE=='') 
         {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe digitar el nombre del tercero', life: 3000 });
            return;
        }
        if(product.DEP_CODIGO=='') 
        {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el departamento de ubicación del tercero', life: 3000 });
            return;
        }
        if(product.MUN_CODIGO=='') 
        {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el municipio de ubicación del tercero', life: 3000 });
            return;
        }        
        if(product.DIRECCION=='') 
        {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe digitar la dirección del tercero', life: 3000 });
            return;
        }         
         if(product.TELEFONOS=='') 
         {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe digitar el teléfono del tercero', life: 3000 });
            return;
        }
        if (!isValidEmail(product.CORREO)) {
            toast.current.show({ 
                severity: 'error', 
                summary: 'Error', 
                detail: 'El formato del correo no es válido (ej: usuario@dominio.com)', 
                life: 3000 
            });
            return; // ⛔ DETIENE la ejecución. No llama al servidor.
        }     
        console.log("SI ESTA ACA "+product.URL)
        if(product.URL!==''){
            if(!isValidURL(product.URL))
            {
                toast.current.show({ 
                severity: 'error', 
                summary: 'Error', 
                detail: 'El formato de la url no es válido (ej: https://dominio.com)', 
                life: 3000 
            });
            return; // ⛔ DETIENE la ejecución. No llama al servidor.
            }         
        }                 
         if(product.FECHA_INGRESO=='') 
        {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar la fecha de ingreso del tercero', life: 3000 });
            return;
        }         
         if(product.ESTADO_TERCERO=='') 
         {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el estado del tercero', life: 3000 });
            return;
        }         
         if(product.TIPO_TERCERO=='') 
         {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el tipo del tercero', life: 3000 });
            return;
        }
         if(product.TIPO_SOCIO=='') 
         {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el tipo de socio para el tercero', life: 3000 });
            return;
        }

        const data = new FormData();
        data.append("TID_TERCERO", product.TID_TERCERO)
        data.append("NID_ASOCIACION", product.NID_ASOCIACION)
        data.append("NOMBRE", product.NOMBRE)
        data.append("DEP_CODIGO", product.DEP_CODIGO)
        data.append("MUN_CODIGO", product.MUN_CODIGO)
        data.append("DIRECCION", product.DIRECCION)
        data.append("TELEFONOS", product.TELEFONOS)
        data.append("CORREO", product.CORREO)
        data.append("URL", product.URL)
        data.append("PROFESION", product.PROFESION)
        data.append("FECHA_INGRESO", product.FECHA_INGRESO)
        data.append("FECHA_RETIRO", product.FECHA_RETIRO)
        data.append("ESTADO_TERCERO", product.ESTADO_TERCERO)
        data.append("TIPO_TERCERO", product.TIPO_TERCERO)
        data.append("TIPO_SOCIO", product.TIPO_SOCIO)
        data.append("NID_TERCERO", product.NID_TERCERO)
        data.append("OPCION", opcion)
        await fetch(TERCEROS + 'ingresarTercero', {
            method: 'POST',
            header: {
                'Accept': 'application/json',
                'Content-type': 'application/json'
            },
            body: data
        }).then((response) => response.json())
            .then((response) => {
                if (response == 1) {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'El Registro ha sido Ingresado o Actualizado', life: 3000 });
                    setReloadUsuarios(true)
                    setSubmitted(false);
                    setProductDialog(false);
                    setProduct(emptyProduct);
                } else {
                    toast.current.show({ severity: 'warning', summary: 'Error', detail: 'El Registro no pudo ser Ingresaro o Actualizado', life: 3000 });
                }
            })
            .catch((error) => {
                console.log(error);
            })

    }

    // Función para validar formato de correo electrónico
const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

// Función para validar formato de URL
const isValidURL = (url) => {
    // Regex que valida URLs completas (http, https, ftp, etc.)
    const regex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i;
    return regex.test(url);
};

    const editProduct = (product) => {
        setProduct({ ...product });
        setOpcion(1)
        setAdicionarRegistro(1)
        setProductDialog(true);
    }

    const confirmDeleteProduct = (product) => {
        setProduct({ ...product }); // Guardamos el producto seleccionado
        
        confirmDialog({
            message: `¿Está seguro que desea eliminar a ${product.NOMBRE}?`,
            header: 'Confirmar Eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sí, eliminar',
            rejectLabel: 'No, cancelar',
            acceptClassName: 'p-button-danger',
            accept: () => deleteProduct(product),  // ✅ Si acepta, ejecuta la eliminación
            reject: () => {
                toast.current.show({
                    severity: 'info',
                    summary: 'Cancelado',
                    detail: 'La eliminación fue cancelada',
                    life: 3000
                });
            }
        });
    }
    
        // 2. Función que realmente elimina el registro en la base de datos
const deleteProduct = async (product) => {
    try {
        const dataVerificar = new FormData();
        dataVerificar.append("NID_TERCERO", product.NID_TERCERO);

        const responseVerificar = await fetch(TERCEROS + 'verificarNidTercero', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: dataVerificar
        });

        const resultado = await responseVerificar.json();
        console.log('Resultado completo:', resultado);

        // Verificar el status de la respuesta
        if (resultado.status === 'eliminado') {
            // El tercero fue eliminado correctamente
            toast.current.show({
                severity: 'success',
                summary: 'Eliminado',
                detail: 'El tercero ha sido eliminado correctamente',
                life: 3000
            });
            setReloadUsuarios(true);
            
        } else if (resultado.status === 'no_eliminado') {
            // El tercero tiene registros asociados
            const tablasConRegistro = resultado.verificacion
                .filter(item => item.existe === 1)
                .map(item => item.tabla);

            const nombres = {
                'anco_semen_importado_a11': 'Semen Importado',
                'anco_registro': 'Registro de animales, debe eliminar primero esta información',
                'anco_nacimiento_a04': 'Nacimiento',
                'anco_monta_directa_a01': 'Monta Directa',
                'anco_lavregembrioa08': 'Lavado de Embriones',
                'anco_inseminacion_a02': 'Inseminación',
                'anco_embrioimporta09': 'Embriones Importados',
                'anco_colecta_semen_a10': 'Colecta de Semen',
                'anco_chips_transferenciaa06': 'Chips Transferencia',
                'anco_arrendamitosa12': 'Arrendamiento',
                'anco_transembrionesa03': 'Transferencia de Embriones'
            };

            const nombresAmigables = tablasConRegistro.map(tabla => nombres[tabla] || tabla);
            const nombresUnicos = [...new Set(nombresAmigables)];

            toast.current.show({
                severity: 'warn',
                summary: 'No se puede eliminar',
                detail: `El tercero tiene registros en: ${nombresUnicos.join(', ')}`,
                life: 8000
            });
            
        } else if (resultado.status === 'error') {
            // Error en el proceso
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: resultado.message || 'Error al procesar la eliminación',
                life: 5000
            });
        }

    } catch (error) {
        console.error('Error al eliminar:', error);
        toast.current.show({
            severity: 'error',
            summary: 'Error de conexión',
            detail: 'No se pudo conectar con el servidor',
            life: 3000
        });
    }
} 


    const exportCSV = () => {
        dt.current.exportCSV();
    }


    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _product = { ...product };
        _product[`${name}`] = val;

        setProduct(_product);
    }


    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Adicionar" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} /> */}
                </div>
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <FileUpload mode="basic" accept="image/*" maxFileSize={1000000} label="Importar" chooseLabel="Importar" className="mr-2 inline-block" />
                <Button label="Exportar" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            </React.Fragment>
        )
    }
    function calcularEdad(fecha, opcion) {
    if (opcion === 1) {
        setProduct(prev => ({
            ...prev,
            FECHA_INGRESO: fecha ? new Date(fecha).toISOString().slice(0, 10) : ''
        }));
    } else if (opcion === 2) {
        setProduct(prev => ({
            ...prev,
            FECHA_RETIRO: fecha ? new Date(fecha).toISOString().slice(0, 10) : ''
        }));
    }
}


    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editProduct(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning mt-2" onClick={() => confirmDeleteProduct(rowData)} />
            </div>
        );
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Terceros</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Enviar" icon="pi pi-check" className="p-button-text" onClick={saveProduct} />
        </>
    );


    // function calcularEdad(fecha,opcion) {

    //     if(opcion==1){
    //         product.FECHA_INGRESO=new Date(fecha).toISOString().slice(0, 10)
    //     }else if(opcion==2){
    //         product.FECHA_RETIRO=new Date(fecha).toISOString().slice(0, 10)
    //     }
    // }
    const hoy = new Date();
    hoy.setHours(23, 59, 59, 999); // Incluye todo el día de hoy

    const handleplanta = async (dato, opc) => {
        setSubmitted(false)
        if (opc == 1) {
            product.DEP_CODIGO = dato
            setDepartamento(dato)
        }else if(opc == 2){
            product.MUN_CODIGO=dato
        }else if(opc == 3){
            product.PROFESION=dato
        }else if(opc == 4){
            product.ESTADO_TERCERO=dato
        }else if(opc == 5){
            product.TIPO_SOCIO=dato
        }else if(opc == 6){
            product.TIPO_TERCERO=dato
        }else if(opc == 7){
            product.NID_ASOCIACION=dato
        }else if(opc == 16){
            product.TID_TERCERO=dato
        }
    }

    return (
        <>
        {value1 &&
            <div className="formgrid grid">
                 <div className="field col">
                   <h5>Consultado información por favor espere</h5>
                       <div className="col">
                       <ProgressBar mode="indeterminate" style={{ height: '16px', width:'auto' }}></ProgressBar>
                   </div>
               </div>
           </div>
           }

        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <div className="formgrid grid">
                        <div className="field col-12">
                    <Toolbar className="mb-4" left={leftToolbarTemplate} ></Toolbar>

                        <DataTable 
                            ref={dt} 
                            value={products} 
                            selection={selectedProducts} 
                            onSelectionChange={(e) => setSelectedProducts(e.value)}
                            dataKey="NID_TERCERO"   // ← CAMBIA "id" por un campo que SÍ exista
                            paginator 
                            rows={10} 
                            rowsPerPageOptions={[5, 10, 25]} 
                            className="datatable-responsive"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} to {last} of {totalRecords} products"
                            globalFilter={globalFilter}
                            globalFilterFields={[           // ← AGREGA ESTO
                                'NID_TERCERO', 
                                'NOMBRE', 
                                'DEPARTAMENTO', 
                                'MUNICIPIO', 
                                'DIRECCION', 
                                'TELEFONOS', 
                                'CORREO', 
                                'TPROFESION',
                                'TESTADO',
                                'TIPO_TERCERO',
                                'TIPO_SOCIO',
                                'NASOCIACION'
                            ]}
                            emptyMessage="No se encontraron registros." 
                            header={header} 
                            responsiveLayout="scroll"
                        >
                        <Column body={actionBodyTemplate}></Column>
                        <Column field="descripcion" header="TID_TERCERO" sortable ></Column>
                        <Column field="NID_TERCERO" header="NID_TERCERO" sortable ></Column>
                        <Column field="NOMBRE" header="NOMBRE" sortable ></Column>
                        <Column field="DEPARTAMENTO" header="DEPARTAMENTO" sortable ></Column>
                        <Column field="MUNICIPIO" header="MUNICIPIO" sortable ></Column>
                        <Column field="DIRECCION" header="DIRECCION" sortable ></Column>
                        <Column field="TELEFONOS" header="TELEFONOS" sortable ></Column>
                        <Column field="CORREO" header="CORREO" sortable ></Column>
                        <Column field="URL" header="URL" sortable ></Column>
                        <Column field="TPROFESION" header="PROFESION" sortable ></Column>
                        <Column field="FECHA_INGRESO" header="FECHA_INGRESO" sortable ></Column>
                        <Column field="FECHA_RETIRO" header="FECHA_RETIRO" sortable ></Column>
                        <Column field="TESTADO" header="ESTADO_TERCERO" sortable ></Column>
                        <Column field="TIPO_TERCERO" header="TIPO_TERCERO" sortable ></Column>
                        <Column field="TIPO_SOCIO" header="TIPO_SOCIO" sortable ></Column>
                        <Column field="NID_ASOCIACION" header="NID_ASOCIACION" sortable ></Column>
                        <Column field="NASOCIACION" header="NOMBRE_ASOCIACION" sortable ></Column>
                    </DataTable>
                    </div>
                    {/* <div className="field col-3"><Lateral/>

                    </div> */}
                    </div>
                    <Dialog visible={productDialog} style={{ width: '650px' }} header="Detalle del Tercero" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                    <div className="formgrid grid">
                             <div className="field col-6">
                                <label htmlFor="name">Tipo Documento Tercero</label>
                                <SeleccionTipoDocumentoOtros handleplanta={handleplanta} NOMBRE={product.descripcion} />
                                {submitted && !product.TID_TERCERO && <small className="p-invalid" required
                                style={{
                                    color: 'red',
                                }}>El tipo de documento es requerido.</small>}
                            </div>
                            <div className="field col">
                            <label htmlFor="name">Nid. tercero</label>
                            <InputText
                                id="name"
                                value={product.NID_TERCERO}
                                onChange={(e) => {
                                    // Solo permite dígitos: elimina puntos, guiones, espacios, letras, etc.
                                    const soloDigitos = e.target.value.replace(/[^0-9]/g, '');
                                    onInputChange({ target: { id: e.target.id, value: soloDigitos } }, 'NID_TERCERO');
                                }}
                                inputMode="numeric"   // Muestra teclado numérico en móviles
                                pattern="[0-9]*"      // Ayuda con validación nativa
                                maxLength={15}        // Ajusta al largo máximo real de tu NID
                                required={adicionarRegistro === 0}
                                readOnly={adicionarRegistro !== 0}   
                                className={classNames({ 'p-invalid': submitted && adicionarRegistro === 0 && !product.NID_TERCERO })} 
                            />
                            {submitted && adicionarRegistro === 0 && !product.NID_TERCERO && (
                                        <small className="p-invalid" style={{ color: 'red' }}>
                                            Número de identificación es requerido
                                        </small>
                            )}
                        </div>
                      </div>
                      <hr/>
                            <div className="field col">
                                    <label htmlFor="name">Nombre del tercero</label>
                                    <InputText id="name" value={product.NOMBRE} onChange={(e) => onInputChange(e, 'NOMBRE')} required />
                                    {submitted && !product.NOMBRE && <small className="p-invalid" required
                                style={{
                                    color: 'red',
                                }}>El nombre es requerido.</small>}
                            </div>
                            <hr/>
                    <div className="formgrid grid">
                    <div className="field col">
                            <label htmlFor="name">Departamento ubicación</label>
                            <SeleccionDepartamento  handleplanta={handleplanta} DEPARTAMENTO={product.DEPARTAMENTO}
                            required
                            />
                            {submitted && !product.DEP_CODIGO && <small className="p-invalid"
                            style={{
                              color: 'red',
                            }}>El departamento es requerido.</small>}
                        </div>
                        <div className="field col">
                            <label htmlFor="name">Municipio ubicación</label>
                            <SeleccionMunicipios  handleplanta={handleplanta} MUNICIPIO={product.MUNICIPIO} CODIGO={departamento}
                            required
                            />
                            {submitted && !product.MUN_CODIGO && <small className="p-invalid"
                            style={{
                              color: 'red',
                            }}>Es municipio es requerido.</small>}
                        </div>
                    </div>
                    <hr/>
                    <div className="formgrid grid">
                        <div className="field col">
                                <label htmlFor="name">Dirección</label>
                                <InputText id="name" value={product.DIRECCION} onChange={(e) => onInputChange(e, 'DIRECCION')} required />
                                {submitted && !product.DIRECCION && <small className="p-invalid" required
                            style={{
                                color: 'red',
                            }}>La dirección es requerida.</small>}
                        </div>
                        <div className="field col">
                                <label htmlFor="name">Teléfono(s)</label>
                                <InputText id="name" value={product.TELEFONOS} onChange={(e) => onInputChange(e, 'TELEFONOS')} required />
                                {submitted && !product.TELEFONOS && <small className="p-invalid" required
                            style={{
                                color: 'red',
                            }}>El teléfono es requerida.</small>}
                        </div>
                    </div>
                    <hr/>
                    <div className="formgrid grid">
                        <div className="field col">
                                <label htmlFor="name">Correo</label>
                                <InputText id="name" value={product.CORREO} onChange={(e) => onInputChange(e, 'CORREO')}  />
                                {submitted && !product.CORREO && <small className="p-invalid" required
                            style={{
                                color: 'red',
                            }}>El correo es requerida.</small>}
                        </div>
                        <div className="field col">
                                <label htmlFor="name">Url</label>
                                <InputText id="name" value={product.URL} onChange={(e) => onInputChange(e, 'URL')}  />
                        </div>
                    </div>
                    <hr/>
                    <div className="formgrid grid">
                        <div className="field col">
    <label htmlFor="dirección">Fecha de Ingreso: {product.FECHA_INGRESO}</label>
    <Calendar 
        showIcon 
        showButtonBar 
        value={product.FECHA_INGRESO ? new Date(product.FECHA_INGRESO) : null}
        dateFormat="yy-mm-dd" 
        monthNavigator={true} 
        yearNavigator={true}
        yearRange="1960:2060" 
        maxDate={hoy}              // ← Bloquea fechas futuras
        required
        onChange={(e) => calcularEdad(e.value, 1)}
    />
    {submitted && !product.FECHA_INGRESO && (
        <small className="p-invalid" style={{ color: 'red' }}>
            La fecha de ingreso es requerida
        </small>
    )}
</div>
                         <div className="field col">
                        <label htmlFor="dirección">Fecha de Retiro: {product.FECHA_RETIRO}</label>
                            <Calendar showIcon showButtonBar value={product.FECHA_RETIRO}
                                dateFormat="yy-mm-dd" monthNavigator={true} yearNavigator={true}
                                yearRange="1960:2060" 
                                readOnlyInput={true}
                                onChange={(e) => calcularEdad(e.value, 2)}></Calendar>
                         </div>
                    </div>
                    <hr/>
                    <div className="formgrid grid">
                         <div className="field col">
                            <label htmlFor="name">Profesión</label>
                            <SeleccionProfesion  handleplanta={handleplanta}  TPROFESION={product.TPROFESION}
                            required
                            />
                            {submitted && !product.PROFESION && <small className="p-invalid"
                            style={{
                              color: 'red',
                            }}>La profesión es requerida.</small>}
                        </div>
                         <div className="field col">
                            <label htmlFor="name">Estado actual</label>
                            <SeleccionEstadoTercero  handleplanta={handleplanta}  MESTADO={product.TESTADO}
                            required
                            />
                            {submitted && !product.ESTADO_TERCERO && <small className="p-invalid"
                            style={{
                              color: 'red',
                            }}>El estado es requerido.</small>}
                        </div>
                    </div>
                    <hr/>
                    <div className="formgrid grid">
                        <div className="field col">
                            <label htmlFor="name">Tipo de socio</label>
                            <SeleccionTipoSocio  handleplanta={handleplanta}  DESCRIPCION={product.TIPO_SOCIO}
                            required
                            />
                            {submitted && !product.TIPO_SOCIO && <small className="p-invalid"
                            style={{
                              color: 'red',
                            }}>El tipo de socio es requerido.</small>}
                        </div>

                        <div className="field col">
                            <label htmlFor="name">Tipo de persona</label>
                            <SeleccionTipoPersona  handleplanta={handleplanta}  DESCRIPCION={product.TIPO_TERCERO}
                            required
                            />
                            {submitted && !product.TIPO_TERCERO && <small className="p-invalid"
                            style={{
                              color: 'red',
                            }}>El tipo de persona es requerida.</small>}
                        </div>
                        <div className="field col">
                            <label htmlFor="name">Asociación</label>
                            <SeleccionTipoAsociacion  handleplanta={handleplanta}  DESCRIPCION={product.NASOCIACION}
                            />
                        </div>


                    </div>

                    </Dialog>


                </div>
            </div>
        </div>
        </>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(Terceros, comparisonFn);
